<template>
<Form
	class="my-3"
	:class="{
		'px-3': isDesktop,
		'px-1': isMobile,
	}"
	@submit="onSubmit"
	@invalid-submit="console.log"
	:validation-schema="schema"
	:initial-values="formValues"
	v-slot="{ errors, meta: meta, }"
>
<fieldset :disabled="!isFormEnabled">
	<div class="row form-row">
		<div class="form-group col-auto mt-2">
			<label>IP адреса КВП</label>
			<Field
				name="ip"
				type="text"
				class="form-control form-control-sm"
				:class="{ 'is-invalid': errors.ip }"
			/>
			<div class="invalid-feedback">{{errors.ip}}</div>
		</div>
	</div>
	<div class="row form-row row-cols-1 my-2">
		<div class="form-group col-auto">
			<Field
				:name="`${Post.passportKeys.notificationDistributionLists.self}.${Post.passportKeys.notificationDistributionLists.connection}`"
				type="checkbox"
				id="allert-on-connection"
				class="form-check-input col-auto"
				:value="true"
				:uncheckedValue="false"
			/>
			<label for="allert-on-connection" class="form-check-label mx-2 my-0 col-auto">
				Сповіщати про втрату зв'язку
			</label>
		</div>
		<span class="form-text fst-italic">
			Сповіщення буде приходити кожного дня о 09:00 якщо КВП не виходив на св'язок більше доби.
		</span>
	</div>

	<div class="row mt-3">
		<label class="fw-bold">Цільовий діапазон захисного потенціалу</label>
	</div>
	<span class="form-text fst-italic">
		<span class="text-decoration-underline">Застосовується для</span> надсилання сповіщень по виходу потенціала за вказаний діапазон.
	</span>
	<div class="row row-cols-1 row-cols-lg-2 form-row">
		<div class="form-group col my-1" style="max-width: 17rem;">
			<label>Мінімальний потенціал</label>
			<Field
				name="reference_potential_range_min"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors.reference_potential_range_min }"
			/>
			<div class="invalid-feedback">{{errors.reference_potential_range_min}}</div>
		</div>
		<div class="form-group col my-1" style="max-width: 17rem;">
			<label>Максимальний потенціал</label>
			<Field
				name="reference_potential_range_max"
				type="number"
				class="form-control form-control-sm no-arrow"
				:class="{ 'is-invalid': errors.reference_potential_range_max }"
			/>
			<div class="invalid-feedback">{{errors.reference_potential_range_max}}</div>
		</div>
		<div class="form-group col align-self-center my-1"></div>
		<div class="form-group col align-self-center my-1">
			<Field
				:name="`${Post.passportKeys.notificationDistributionLists.self}.potential_out_of_range`"
				type="checkbox"
				class="form-check-input"
				:value="true"
				:uncheckedValue="false"
			/>
			Сповіщати про вихід за діапазон
		</div>
	</div>

	<!-- <pre>Errors: {{ errors }}</pre> -->
	<!-- <pre>Is valid: {{ meta.valid }}</pre> -->
	<!-- <pre>Form values: {{ formValues }}</pre> -->

	<div class="row form-row my-1">
		<span class="form-text fst-italic">
			<p
				class="fs-5 text-center"
				:class="{'text-success': executionOk, 'text-danger': !executionOk}"
			>
				&nbsp;{{ executionResultMessage }}
			</p>
		</span>
	</div>
	<div class="row form-row mt-1 mb-3">
		<div class="form-group col-auto ms-auto me-2">
			<button
				type="reset"
				class="btn btn-secondary btn-sm mx-2"
			>
				Відмінити
			</button>
		</div>
		<div class="form-group col-auto me-0">
			<button
				type="submit"
				class="btn btn-primary btn-sm"
				:disabled="!meta.valid"
			>
			<!-- @click="formMeta=meta" -->
				Зберегти
			</button>
		</div>
	</div>
</fieldset>
</Form>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore'
import { usePostsStore } from '@/stores/PostsStore'
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'
// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
import { Form, Field } from 'vee-validate';
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
//import * as Yup from 'yup';
import { SettingsSchema } from "@/models/objectPrototype.js"
import { Post } from '@/models/post'

export default {
	requiredPromt: 'Обов\'язкове поле',
	overMinLenPromt: 'Довжина меньше мінімальної',
	overMaxLenPromt: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',
	onlyIntegersPromt: 'Має бути цілим числом',
	onlyPositivePromt: 'Має бути натуральним числом',
	wrongInputPromt: 'Не відповідає вимогам',

	components: {
		Form,
        Field,
	},

	props: {
		postId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()
		const { isDesktop, isMobile } = useSizeBreakpoint()

		return {
			accountStore,
			postsStore,
			isDesktop,
			isMobile,
			Post,
		}
	},

	data() {
		const schema = SettingsSchema

		return {
			//------------------ Form
			schema,
			formValues: {},
			//formMeta: {},
			//-----------------------
			//  
			executionResultMessage: '',
			executionOk: null,
		}
	},

	created() {
		// Read post passport
		this.postsStore.readPassport((result) => {
			if (result) {
				const passport = Object.fromEntries(this.postsStore.post(this.postId).passport)

				// If notification lists is present in passport
				if (passport[Post.passportKeys.notificationDistributionLists.self]) {
					// Parse notification Distribution Lists
					const parsedNotificationsList = {}
					for (const [key, value] of Object.entries(passport[Post.passportKeys.notificationDistributionLists.self])) {
						// Add notification flag to parsed lists
						parsedNotificationsList[key] = value.includes(this.accountStore.userId)
					}
					passport[Post.passportKeys.notificationDistributionLists.self] = parsedNotificationsList
				}

				this.formValues = passport
				//console.log("Settings", this.formValues)
			} else {
				console.error("Can't read post passport!")
			}
		}, this.postId);
	},

	mounted() {
	},

	methods: {
		onCancel() {},

		onSubmit(values) {
			//console.log("values", values)
			// console.log("formMeta", this.formMeta)
			this.executionOk = null
			this.executionResultMessage = ''

			// Parse notification_distribution_lists and convert to passport format
			let notificationDistributionLists = this.post?.passport.get(Post.passportKeys.notificationDistributionLists.self)
			if (!notificationDistributionLists) {
				this.post.passport.set(Post.passportKeys.notificationDistributionLists.self, new Object())
				notificationDistributionLists = this.post.passport.get(Post.passportKeys.notificationDistributionLists.self)
			}
			for (const [key, value] of Object.entries(values[Post.passportKeys.notificationDistributionLists.self])) {
				const userId = this.accountStore.userId
				
				// If notification is enable
				if (value) {
					// if no list at all
					if (notificationDistributionLists[key] === undefined) {
						notificationDistributionLists[key] = []
					}
					// If current user is not in distribution notifications list
					if (!notificationDistributionLists[key].includes(userId)) {
						notificationDistributionLists[key].push(userId)
					}
				} else {
					// If current user is in distribution notifications list
					if (notificationDistributionLists[key] !== undefined
						&& notificationDistributionLists[key].includes(userId)
					) {
						const index = notificationDistributionLists[key].indexOf(userId);
						notificationDistributionLists[key].splice(index, 1)
					}
				}
			}
			// Add notification_distribution_lists to form values
			values[Post.passportKeys.notificationDistributionLists.self] = notificationDistributionLists

			values[Post.passportKeys.updateBy] = this.accountStore.userId
			
			this.postsStore.updatePasport((result) => {
				if (result) {
					//console.log("Passport updates successfuly")
					this.executionOk = true
					this.executionResultMessage = 'Налаштування записані успішно'
				} else {
					//console.error("Passport update error")
					this.executionOk = false
					this.executionResultMessage = 'Помилка запису.'
				}
			}, this.postId, values)			
        },
	},

	computed: {
		post() { return this.postsStore.post(this.postId); },
		isFormEnabled() { return this.accountStore.permissions.includes('manage_posts') },
	},
}
</script>


<style src="../../assets/widget.css" scoped></style>
<style scoped>
/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	appearance: textfield;
	-moz-appearance: textfield;
}

.input-min-width {
	min-width: 53ch; 
	max-width: 53ch;
	/* width: 53ch; */
}
</style>